import { PROJECT_ID_PREFIX } from "@grafit/shared/domain/project/project";
import { isTypeId, parseTypeId } from "@grafit/shared/utils/typeid";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { DealLayout } from "../../../../pages/deal-redirect-page/deal-layout/deal-layout";

export const Route = createFileRoute("/_auth/_deal/deals/$dealId")({
  beforeLoad: ({ params }) => {
    if (!isTypeId(params.dealId, PROJECT_ID_PREFIX)) {
      throw notFound();
    }
    return { dealId: parseTypeId(params.dealId, PROJECT_ID_PREFIX) };
  },
  component: DealLayout,
});
